import { useMemo, useState } from "react";
import InstancesToolbar from "./InstancesToolbar";
import InstancesTable from "./InstancesTable";
import ContainerLogsModal from "./ContainerLogsModal";
import useInstancesStream from "./useInstancesStream";
import usePageTitle from "../../services/usePageTitle";
import PageLayout from "../../components/PageLayout";
import instancesHelp from "../../content/help/instances.json";

export default function Instances({ pageTitle = "Instances" }) {
  usePageTitle("Instances - SkeyeGate™");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [moduleFilter, setModuleFilter] = useState("all");
  const [selectedRow, setSelectedRow] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(1);

  const { data, loading, error, modules, isBackendDown } = useInstancesStream();
  //if (error) message.error("Live update failed, retrying...");

  const filtered = useMemo(() => {
    if (isBackendDown) return []; // <-- Forces empty table when backend is down

    const term = search.trim().toLowerCase();
    return data.filter((row) => {
      if (statusFilter !== "all" && row.status !== statusFilter) return false;
      if (moduleFilter !== "all" && row.label !== moduleFilter) return false;
      if (!term) return true;
      return Object.values(row).some((v) =>
        v ? v.toString().toLowerCase().includes(term) : false,
      );
    });
  }, [data, search, statusFilter, moduleFilter, isBackendDown]);

  return (
    <div className="instances-page">
      <PageLayout
        title={pageTitle}
        helpContent={instancesHelp}
        description="Monitor container health, resource usage, and inspect logs in real time."
      >
        <InstancesToolbar
          search={search}
          onSearchChange={setSearch}
          statusFilter={statusFilter}
          onStatusChange={setStatusFilter}
          moduleFilter={moduleFilter}
          onModuleChange={setModuleFilter}
          moduleOptions={modules}
          live={!isBackendDown}
        />

        <InstancesTable
          data={filtered}
          loading={loading && !isBackendDown}
          isBackendDown={isBackendDown}
          onOpenLogs={(row) => setSelectedRow(row)}
          page={page}
          pageSize={pageSize}
          onPageChange={(p, size) => {
            setPage(p);
            setPageSize(size);
          }}
        />

        <ContainerLogsModal
          open={!!selectedRow}
          onClose={() => setSelectedRow(null)}
          containerId={selectedRow?.id}
          containerName={selectedRow?.name}
        />
      </PageLayout>
    </div>
  );
}
